import axios from 'axios';
import { ElMessage, ElLoading } from 'element-plus';
import router from '@/router';
import { API_CONFIG, STORAGE_KEYS, RESPONSE_CODE, storage, BASE_URL } from './config';

// 创建 axios 实例
const api = axios.create({
  baseURL:  process.env.NODE_ENV === 'production'
  ? BASE_URL
  : API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT
});

// 添加公共参数
const addCommonParams = (config) => {
  const commonParams = {
    // shopid: storage.get(STORAGE_KEYS.SHOP_ID),
    // uid: storage.get(STORAGE_KEYS.UID),
  };

  if (config.data instanceof FormData) {
    // 如果是 FormData，使用 append 方法添加公共参数
    for (const key in commonParams) {
      config.data.append(key, commonParams[key]);
    }
  } else if (config.method === 'get') {
    // 对于 GET 请求，将公共参数添加到 params 中
    config.params = { ...config.params, ...commonParams };
  } else if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
    // 对于 POST 请求，将公共参数添加到 data 中
    config.data = { ...config.data, ...commonParams };
  }

  return config;
};

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 添加 token
    const userInfo = storage.get(STORAGE_KEYS.USER_INFO);
    if (!userInfo && config.url != "/login/dologin") {
      router.push('/login');
      return Promise.reject({code:401,msg:"未登录"});
    }

    const token = storage.get(STORAGE_KEYS.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const configdata = config.data ? config.data : {};
    config.data = configdata;

    // 动态设置 Content-Type
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      if (userInfo && userInfo instanceof Object) {
        config.data['api_key'] = userInfo.api_key;
      }
    }

    // 添加公共参数
    return addCommonParams(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    const res = response.data;
   
    if (res.code == 999 || res.code == '999') {
      // ElMessage({
      //   message: res.msg || '请重新登录！',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      storage.remove(STORAGE_KEYS.USER_INFO)
      router.push('/login?isreload=1')
      return res
    }

    // 根据状态码处理响应
    if (res.code === RESPONSE_CODE.SUCCESS) {
      return res;
    }
    
    // 处理特定错误码
    switch (res.code) {
      case RESPONSE_CODE.UNAUTHORIZED:
        // 清除用户信息并跳转到登录页
        storage.remove(STORAGE_KEYS.TOKEN);
        storage.remove(STORAGE_KEYS.USER_INFO);
        router.push('/login');
        break;
      default:
        ElMessage.error(res.msg || '请求失败');
    }
    
    return Promise.reject(res);
  },
  (error) => {
    // 请求失败，处理错误
    if (error.response) {
      switch (error.response.status) {
        case RESPONSE_CODE.UNAUTHORIZED:
          storage.remove(STORAGE_KEYS.TOKEN);
          storage.remove(STORAGE_KEYS.USER_INFO);
          router.push('/login');
          break;
        default:
          ElMessage.error(`请求错误: ${error.response.status}`);
      }
    } else {
      ElMessage.error('网络错误，请检查连接');
    }
    return Promise.reject(error);
  }
);

// 封装 GET 请求
export const get = (url, params = {}, showLoading = true) => {
  let loading;
  if (showLoading) {
    loading = ElLoading.service({ text: '加载中...', background: 'rgba(0, 0, 0, 0.7)' });
  }
  return api
    .get(url, { params })
    .finally(() => {
      if (loading) loading.close();
    });
};

// 封装 POST 请求
export const post = (url, data = {}, showLoading = true) => {
  let loading;
  if (showLoading) {
    loading = ElLoading.service({ text: '加载中...', background: 'rgba(0, 0, 0, 0.7)' });
  }
  return api
    .post(url, data)
    .finally(() => {
      if (loading) loading.close();
    });
};

// 导出请求方法和原始实例
export default {
  get,
  post,
  request: api,
  api
};